<!-- error alert -->
@if (scanDetailsSaveError()) {
  <div class="w-full mb-4">
    <modus-alert
      class="w-full"
      message="{{ translations.saveError.text }}"
      type="error"
    ></modus-alert>
  </div>
}

<div [formGroup]="formGroup" class="flex flex-col">
  <sd-label-value
    data-cy="properties-status"
    label="{{ translations.status.text }}"
    value="{{ scandataModel().pointcloudStatus }}"
  ></sd-label-value>

  @if (readonly()) {
    <sd-label-value
      data-cy="properties-capture-date-label"
      label="{{ translations.captureDate.text }}"
      value="{{ scandataModel().captureDate | date: 'mediumDate' | dashedIfEmpty }}"
    ></sd-label-value>
  } @else {
    <modus-date-picker label="{{ translations.captureDate.text }}" class="-mt-1 mb-4">
      <modus-date-input
        data-cy="properties-capture-date-input"
        type="single"
        format="yyyy-mm-dd"
        allowed-chars-regex="[\d-]"
        show-calendar-icon="true"
        [max]="maxCaptureDate"
        [formControl]="formGroup.controls.captureDate"
        (dateInputBlur)="saveChange(formGroup.controls.captureDate)"
      ></modus-date-input>
    </modus-date-picker>
  }

  <sd-label-value
    data-cy="properties-uploaded-by"
    label="{{ translations.uploadedBy.text }}"
    value="{{ scandataModel().uploadedBy }}"
  ></sd-label-value>

  <sd-label-value
    data-cy="properties-upload-date"
    label="{{ translations.uploadedDate.text }}"
    value="{{ scandataModel().uploadedDate | date: 'medium' }}"
  ></sd-label-value>

  @if (readonly()) {
    <sd-label-value
      data-cy="properties-scanner-type-label"
      label="{{ translations.scannerType.text }}"
      value="{{ scandataModel().scannerType | dashedIfEmpty }}"
    ></sd-label-value>
  } @else {
    <modus-form-field class="mb-2">
      <modus-label>{{ translations.scannerType.text }}</modus-label>
      <input
        modus-input
        data-cy="properties-scanner-type-input"
        [formControl]="formGroup.controls.scannerType"
        (blur)="saveChange(formGroup.controls.scannerType)"
        (keydown.enter)="saveChange(formGroup.controls.scannerType)"
      />
    </modus-form-field>
  }

  <sd-label-value
    data-cy="properties-number-of-stations"
    label="{{ translations.numberOfStations.text }}"
    value="{{ scandataModel().numberOfStations }}"
  ></sd-label-value>

  @if (showName()) {
    @if (readonly()) {
      <sd-label-value
        label="{{ translations.pointCloudName.text }}"
        value="{{ scandataModel().name }}"
      ></sd-label-value>
    } @else {
      <modus-form-field class="mb-2">
        <modus-label>{{ translations.pointCloudName.text }}</modus-label>
        <input
          modus-input
          data-cy="properties-point-cloud-name-input"
          [formControl]="formGroup.controls.name"
          (blur)="saveChange(formGroup.controls.name)"
          (keydown.enter)="saveChange(formGroup.controls.name)"
        />
      </modus-form-field>
    }
  }

  <sd-label-value
    data-cy="properties-point-count"
    label="{{ translations.pointCount.text }}"
    value="{{ scandataModel().pointCount | pointCount: 3 | dashedIfEmpty }}"
  ></sd-label-value>

  <sd-label-value
    data-cy="properties-classified"
    label="{{ translations.isClassified.text }}"
    value="{{ scandataModel().isClassified ? 'Yes' : 'No' }}"
  ></sd-label-value>

  <sd-label-value
    data-cy="properties-point-cloud-area"
    label="{{ translations.area.text }}"
    value="{{ scandataModel().area ?? 0 | area | dashedIfEmpty }}"
  ></sd-label-value>

  <sd-label-value
    data-cy="properties-point-cloud-location"
    label="{{ translations.location.text }}"
    value="{{ locationSummary() | dashedIfEmpty }}"
  ></sd-label-value>

  <sd-label-value
    data-cy="properties-file-size"
    label="{{ translations.fileSize.text }}"
    value="{{ scandataModel().fileSize | fileSize: 1 | dashedIfEmpty }}"
  ></sd-label-value>

  @if (readonly()) {
    <sd-label-value
      data-cy="properties-notes-label"
      label="{{ translations.notes.text }}"
      value="{{ scandataModel().notes | dashedIfEmpty }}"
    ></sd-label-value>
  } @else {
    <modus-form-field class="mb-2">
      <modus-label>{{ translations.notes.text }}</modus-label>
      <textarea
        modus-input
        data-cy="properties-notes-textarea"
        [formControl]="formGroup.controls.notes"
        (blur)="saveChange(formGroup.controls.notes)"
      ></textarea>
    </modus-form-field>
  }

  @if (showTags()) {
    <div>
      <modus-label class="text-xs">{{ translations.tags.text }}</modus-label>
      <div class="flex justify-start flex-wrap">
        @for (tag of scandataModel().tags; track tag) {
          <modus-chip class="m-1" [value]="tag" data-cy="properties-tag-chip"></modus-chip>
        }
      </div>
    </div>
  }
</div>
